/* 🤖 this file was generated by svg-to-ts */
export const matIconFormatItalic: {
  name: 'format-italic';
  data: string;
} = {
  name: 'format-italic',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4h-8z"/></svg>`
};
